import { Component } from '@angular/core';
import { FileTransferService } from '../services/file-transfer.service';

@Component({
  selector: 'app-masterfile-management',
  templateUrl: './masterfile-management.component.html',
  styleUrls: ['./masterfile-management.component.css'],
  standalone: false
})
export class MasterfileManagementComponent {
  protected masterFileToUpload: File | undefined;
  private projectFileToUpload: File | undefined;

  protected selectMasterFileText = '+ Drag Masterfile here or…';

  constructor(private readonly fileTransferService: FileTransferService) {}

  onMasterFileChanged(event: Event) {
    const files: File[] = (event as CustomEvent).detail;
    this.masterFileToUpload = files && files.length > 0 ? files[0] : undefined;
    if (this.masterFileToUpload) {
      this.selectMasterFileText = this.masterFileToUpload.name;
    }
  }

  onProjectFileChanged(event: Event) {
    const files: File[] = (event as CustomEvent).detail;
    this.projectFileToUpload = files && files.length > 0 ? files[0] : undefined;
  }

  downloadMasterFile() {
    this.fileTransferService.downloadFile('Masterfile');
  }

  uploadMasterfile() {
    if (this.masterFileToUpload !== undefined) {
      this.fileTransferService.uploadFile('Masterfile', this.masterFileToUpload);
    }
  }

  uploadProjectFile() {
    if (this.projectFileToUpload !== undefined) {
      this.fileTransferService.uploadFile('Project', this.projectFileToUpload);
    }
  }
}
